import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AuthApi } from '../../../api/AuthApi';
const initialState = {
  status: false,
  message: '',
  data: {},
  currentRequestId: undefined,
  loading: 'idle',
  action: '',
  error: null
};
export const login = createAsyncThunk(
  'auth/login',
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().login;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.login({ values: authData });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const twoFactorSetup = createAsyncThunk(
  'auth/twoFactorSetup',
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().login;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.twoFactorSetup(authData);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const twoFactorConfirmation = createAsyncThunk(
  'auth/twoFactorConfirmation',
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().login;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.twoFactorConfirmation(authData);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resetPass = createAsyncThunk(
  'auth/resetPass',
  async (email, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().login;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.resetPass(email);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changePass = createAsyncThunk(
  'auth/changePass',
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().login;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.changePass(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const confirmResetPass = createAsyncThunk(
  'auth/confirmResetPass',
  async (payload, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().login;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.confirmResetPass({ values: payload });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resetLogin = createAsyncThunk(
  'auth/resetLogin',
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().login;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = initialState;
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const loginSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'login';
          state.error = null;
        }
      })
      .addCase(login.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = { ...action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(login.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetPass.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'reset_pass';
          state.error = null;
        }
      })
      .addCase(resetPass.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = { ...state.data, reset_pass_data: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetPass.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(confirmResetPass.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'confirm_reset_pass';
          state.error = null;
        }
      })
      .addCase(confirmResetPass.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = { ...state.data, confirm_pass_data: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(confirmResetPass.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(twoFactorSetup.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'two_factor_setup';
          state.error = null;
        }
      })
      .addCase(twoFactorSetup.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = { ...state.data, two_f_setup: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(twoFactorSetup.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(twoFactorConfirmation.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'two_factor_confirmation';
          state.error = null;
        }
      })
      .addCase(twoFactorConfirmation.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = { ...state.data, two_f_confirm: action.payload };
          state.status = action.payload.status;
          state.action = 'done'; // reset login flow
          state.currentRequestId = undefined;
        }
      })
      .addCase(twoFactorConfirmation.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      }).addCase(resetLogin.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = '';
          state.error = null;
        }
      })
      .addCase(resetLogin.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = {};
          state.status = action.payload.status;
          state.action = ''; // reset login flow
          state.currentRequestId = undefined;
        }
      })
      .addCase(resetLogin.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      }).addCase(changePass.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'change_pass';
          state.error = null;
        }
      })
      .addCase(changePass.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = { ...state.data, change_pass_data: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(changePass.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  }
});

export default loginSlice.reducer;
